import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=619253b4&scoped=true&"
import script from "./contact-info.vue?vue&type=script&lang=js&"
export * from "./contact-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619253b4",
  null
  
)

export default component.exports